import { ACTION_DETAILS, ACTION_LIST } from "models/role/action";
import { SUBJECT_BACKOFFICE_TRANSACTIONS } from "models/role/subject";

import type { RouteCan } from "routes/RouteModel";

// Mirrors the backend, which needs PERMISSION_BACKOFFICE_TRANSACTION_VIEW to
// list and open transactions. Only Volt employees are granted it. Transaction
// actions check the _MANAGE permission on their own.
export const BACKOFFICE_PERMISSIONS = {
  transactionsList: { do: ACTION_LIST, on: SUBJECT_BACKOFFICE_TRANSACTIONS },
  transactionDetails: {
    do: ACTION_DETAILS,
    on: SUBJECT_BACKOFFICE_TRANSACTIONS,
  },
} as const satisfies Record<string, RouteCan>;
